/**
 * Get browser geolocation data
 * @type {HTMLElement}
 */
var input = document.getElementById("location");
export function getLocation() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition, blocked);
    } else {
        alert("Geolokácia nie je podporovaná v tomto prehliadači.");
    }
}

function showPosition(position) {
    var location = position.coords.latitude + ',' + position.coords.longitude;

    input.value = location;
    document.cookie = "geoloc=" + location;
}

function blocked() {
    alert("Nemáte povolenú geolokáciu pre túto stránku.\nSkontrolujte nastavenia stránky v lište s adresou.");
}
